import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bexub9fxt6: FaireBrandEntity = {
  token: "b_bexub9fxt6",
  type: "brand",
  name: "Dot & Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/8ec23ddc6a2fa3ed7cc9968032e3d9aef9152cc0c970bcd897b4af5190b1cad9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a4f302485ce282154d97852b09888cdc50579be2d97e6d3b32eb6eb8e6547cce.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8ec23ddc6a2fa3ed7cc9968032e3d9aef9152cc0c970bcd897b4af5190b1cad9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a4f302485ce282154d97852b09888cdc50579be2d97e6d3b32eb6eb8e6547cce.jpeg",
  location: "Centennial, CO, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 40,
  isTopShop: true,
  isInsider: true,
  description:
    "Our Story\n\nFor nearly 36 years, I’ve worked in the nail and self-care industry—educating for major brands, owning The Pink Door Nail Salon & Boutique in Brighton, Colorado, and working alongside my two talented daughters.\n\nAs life evolved, including caring for my aging parents, I added a small home-based salon in Centennial, CO. During that time, I continued searching for exfoliating and moisturizing products that truly met my standards for ingredients, performance, and experience. When I couldn’t find exactly what I wanted, I decided to create it.\n\nDot & Co was built from decades of hands-on professional experience and a belief that everyday care should feel intentional, simple, and special.\n\nOur signature Butter Babees and Sugar Babees are handcrafted with all-natural ingredients and designed for single-use exfoliation and moisturization. These individual beads offer a hygienic, giftable, and approachable way for customers to enjoy thoughtful self-care—at home or on the go.\n\nEvery product we make reflects intentional formulation, practical design, and a genuine love for small daily rituals.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:25.049Z",
    importedBy: "entity-db-cli",
  },
};
